module.exports = __webpack_public_path__ + "static/pilbara-solar-1136a97592ed5e43f9f97e4fb9b02f87.png";